import React from "react";
import { Box, Typography } from "@mui/material";
import { useThemeContext } from "../../Context/ThemeContext";
import { DARKCOLORS, LIGHTCOLORS } from "../../Utils/constants";
import { useTranslation } from "react-i18next";

// Reusable pill-style status badge (colored dot + label), modeled on the
// getStatusBadgeStyles pattern in Pages/Manage/VendingMachines/CardComponent.js.
// Color scheme: green = Active, red = Expired, yellow = Inactive / In Progress,
// grey = no status.
const StatusBadge = ({ status, label }) => {
  const { mode } = useThemeContext();
  const { t } = useTranslation();

  // Theme-aware colors — same light/dark pairs as CardComponent
  const colorSuccess = mode === 'dark' ? DARKCOLORS.Success700 : LIGHTCOLORS.Success700;
  const colorSuccess1 = mode === 'dark' ? DARKCOLORS.Success100 : LIGHTCOLORS.Success100;
  const colorSuccess3 = mode === 'dark' ? DARKCOLORS.Success500 : LIGHTCOLORS.Success500;

  const colorDanger = mode === 'dark' ? DARKCOLORS.Danger500 : LIGHTCOLORS.Danger500;
  const colorDanger1 = mode === 'dark' ? DARKCOLORS.Danger100 : LIGHTCOLORS.Danger100;
  const colorDanger3 = mode === 'dark' ? DARKCOLORS.Danger600 : LIGHTCOLORS.Danger600;

  const colorWarning = mode === 'dark' ? DARKCOLORS.Warning500 : LIGHTCOLORS.Warning500;
  const colorWarning1 = mode === 'dark' ? DARKCOLORS.Warning100 : LIGHTCOLORS.Warning100;
  const colorWarning2 = mode === 'dark' ? DARKCOLORS.Warning700 : LIGHTCOLORS.Warning700;
  const colorWarning3 = mode === 'dark' ? DARKCOLORS.Warning300 : LIGHTCOLORS.Warning300;

  const greyBadgeBg = mode === 'dark' ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
  const greyBadgeBorder = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.GreyScale60;
  const greyBadgeText = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;

  // Reference: getStatusBadgeStyles in CardComponent.js (lines 56-86)
  const getStatusBadgeStyles = (status) => {
    if (!status) {
      return {
        backgroundColor: greyBadgeBg,
        border: `1px solid ${greyBadgeBorder}`,
        //dotColor: greyBadgeText,
        textstyle: greyBadgeText,
      };
    }
    switch (status) {
      case "Active":
        return {
          backgroundColor: colorSuccess1,
          border: `1px solid ${colorSuccess3}`,
          //dotColor: colorSuccess,
          textstyle: colorSuccess,
        };
      case "Expired":
        return {
          backgroundColor: colorDanger1,
          border: `1px solid ${colorDanger}`,
          //dotColor: colorDanger,
          textstyle: colorDanger3,
        };
      case "Inactive":
      case "In Progress":
      default:
        return {
          backgroundColor: colorWarning1,
          border: `1px solid ${colorWarning3}`,
         // dotColor: colorWarning,
          textstyle: colorWarning2,
        };
    }
  };

  // Status value to translated label mapping (mirrors TableComponent)
  const statusLabels = {
    "Active": t("membershipCards.active"),
    "Expired": t("membershipCards.expired"),
    "Inactive": t("membershipCards.inactive"),
    "In Progress": t("serviceRequest.inprogress"),
  };

  const styles = getStatusBadgeStyles(status);
  const text = label || statusLabels[status] || status || t("sales_analytics.NoData");

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "4px 10px",
        borderRadius: "99px",
        backgroundColor: styles.backgroundColor,
        border: styles.border,
        width: "fit-content",
      }}
    >
      
    
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 500,
          color: styles.textstyle,
          fontFamily: "Satoshi-medium",
          whiteSpace: "nowrap",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default StatusBadge;
